import { Injectable } from '@angular/core';
import { EntityStore, StoreConfig } from '@datorama/akita';

import { AuthLocationUserState } from './auth-location-user.state';

@Injectable({providedIn: 'root'})
@StoreConfig({ name: 'authLocationUsers', resettable: true, idKey: 'id' })
export class AuthLocationUserStore extends EntityStore<AuthLocationUserState> {
  constructor() {
    super();
  }
}
